import { render } from "./projectWrapper.vue?vue&type=template&id=5d6dc731&scoped=true"
import script from "./projectWrapper.vue?vue&type=script&lang=js"
export * from "./projectWrapper.vue?vue&type=script&lang=js"

import "./projectWrapper.vue?vue&type=style&index=0&id=5d6dc731&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6dc731"]])

export default __exports__